<template>
  <div style='padding: 25px' class='entrust'>
    <div-border label='选择车辆' style='padding: 20px'>
      <el-form :model='EntrustForm' label-width='60px' :inline='true' class='demo-form-inline'>
        <div style='display:flex;'>
          <el-form-item label='批次号' style='flex:8;margin:0;'>
            <el-input size='mini' v-model='EntrustForm.batchNumber' placeholder='请输入批次号'></el-input>
          </el-form-item>
          <el-form-item label='运单号' style='flex:8;margin:0;'>
            <el-input size='mini' v-model='EntrustForm.waybillNo' placeholder='请输入运单号'></el-input>
          </el-form-item>
          <el-form-item label='车架号' style='flex:8;margin:0;'>
            <el-input size='mini' v-model='EntrustForm.frameNumber' placeholder='请输入车架号'></el-input>
          </el-form-item>
        </div>
        <div style='display:inline-block;width:100%;text-align:right;padding:5px 5px 10px'>
          <el-button size='mini' class='searchBtn' @click='EntrustSearchBtn'>查询</el-button>
          <el-button size='mini' class='resetBtn' @click='EntrustResetBtn'>重置</el-button>
        </div>
        <div>
          <!-- <el-table
            :data="EntrustTable"
            v-loading="tableLoad"
            style="width: 100%"
            border
            :header-cell-style="{'color':'#7F7F7F','padding':'0px','font-size':'13px',height:'35px'}"
            :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
            tooltip-effect="dark"
            row-key="id"
            ref="carTableRef"
            @selection-change="EntrustSelectChange"
            v-if="type!=='转船'"
          >
            <el-table-column type="selection" reserve-selection width="50" align="center"></el-table-column>
            <el-table-column label="批次号" prop="batchNumber" width="130" align="center" />
            <el-table-column label="车架号" prop="frameNumber" width="130" align="center" />
            <el-table-column label="品牌" prop="brandName" align="center" />
            <el-table-column label="型号" prop="modelName" width="150" align="center" />
            <el-table-column label="配置" prop="config" align="center" />
            <el-table-column label="颜色" prop="color" align="center" />
            <el-table-column label="重量" prop="weight" width="60" align="center" />
            <el-table-column label="长x宽x高" prop="lwh" width="90" align="center"/>
          </el-table>
          <div style="margin-top: 20px" v-if="type!=='转船'">
            <span style="vertical-align: sub;">共{{total}}条</span>
            <el-pagination
              background
              style="display: inline-block;"
              :page-sizes="[10, 20, 30, 40]"
              layout="sizes,prev, pager, next,jumper"
              :total="total"
              @size-change="contractSizeChange"
              @current-change="contractCurrentChange"
              @prev-click="contractCurrentChange"
              @next-click="contractCurrentChange"
            />
          </div> -->
          <el-table
            :data='EntrustTable'
            v-loading='tableLoad'
            style='width: 100%'
            border
            :header-cell-style="{'color':'#7F7F7F','font-size':'13px',height:'35px'}"
            :cell-style="{'color':'#7F7F7F','font-size':'13px'}"
            tooltip-effect='dark'
            ref='carTableRef'
            row-key='id'
            @selection-change='EntrustSelectChange'
            v-if="type==='转船'"
            :reserve-selection='true'
          >
            <el-table-column type='selection' reserve-selection width='50'
                             align='center'></el-table-column>
            <el-table-column label='批次号' prop='batchNumber' width='110px' align='center' />
            <el-table-column label='运单号' prop='waybillNo' width='130px' align='center' />
            <el-table-column label='车架号' prop='frameNumber' width='160px' align='center' />
            <el-table-column label='品牌' prop='brand' min-width='100' align='center' />
            <el-table-column label='型号' prop='model' min-width='130' align='center' />
            <el-table-column label='重量' prop='weight' align='center' />
          </el-table>
          <div style='margin-top: 20px'>
            <el-pagination
              background
              :page-sizes='[10, 20, 30, 40]'
              layout='total, sizes, prev, pager, next, jumper'
              :total='total'
              @size-change='contractSizeChange'
              @current-change='contractCurrentChange'
              :current-page.sync='EntrustForm.page'
              :page-size='EntrustForm.rows'
            />
          </div>
        </div>
        <div class='footer'>
          <el-form-item>
            <el-button size='mini' class='searchBtn' @click='determine'>确定</el-button>
            <el-button size='mini' class='resetBtn' @click='close2'>取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div-border>
  </div>
</template>

<script>
  import {
    vehiclGetChildByPosition,
    changeShipSelectCarByShipIdAndOut,
  } from '@/service/vehiclelog';
  import divBorder from '@/components/divBorder';

  export default {
    name: 'addEntrust',
    components: {
      divBorder,
    },
    props: {
      // 父组件传入参数 表格id，用于回显
      selectTableId: {
        default: [],
      },
      positionData: {
        type: Object,
        default: () => {
        },
      },
      type: {
        default: '',
      },
    },
    data() {
      return {
        EntrustForm: {
          batchNumber: '',
          frameNumber: '',
          waybillNo: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        EntrustTable: [],
        selectTable: [],
      };
    },
    inject: ['CloseDialog'],
    methods: {
      // 船舶调配
      async _vehiclGetChildByPosition() {
        this.tableLoad = true;
        let res = await vehiclGetChildByPosition({
          positionType: this.positionData.positionType,
          positionId: this.positionData.positionId,
          ...this.EntrustForm,
        });
        if (res.status !== 0) {
          this.tableLoad = false;
          return this.$message.error(res.message);
        }
        this.EntrustTable = res.data.records;
        this.total = res.data.total;
        this.tableLoad = false;
      },
      // 船舶调配分页
      contractSizeChange(size) {
        this.EntrustForm.rows = size;
        switch (this.type) {
          case '船舶调配':
            this._vehiclGetChildByPosition();
            break;
          case '转船':
            this._changeShipSelectCarByShipIdAndOut();
            break;
        }
      },
      contractCurrentChange(page) {
        this.EntrustForm.page = page;
        switch (this.type) {
          case '船舶调配':
            this._vehiclGetChildByPosition();
            break;
          case '转船':
            this._changeShipSelectCarByShipIdAndOut();
            break;
        }
      },

      // 转船
      async _changeShipSelectCarByShipIdAndOut() {
        this.tableLoad = true;
        let res = await changeShipSelectCarByShipIdAndOut({
          personnelId: this.positionData.shipId,
          ...this.EntrustForm,
        });
        if (res.status !== 0) {
          this.tableLoad = false;
          return this.$message.error(res.message);
        }
        this.EntrustTable = res.data.records;
        this.total = res.data.total;
        this.tableLoad = false;
        // this.selectEcho();
      },
      EntrustResetBtn() {
        for (let argumentsKey in this.EntrustForm) {
          this.EntrustForm[argumentsKey] = '';
        }
        this.EntrustForm.page = 1;
        this.EntrustForm.rows = 10;
      },
      EntrustSelectChange(value) {
        this.selectTable = value;
      },
      EntrustSearchBtn() {
        switch (this.type) {
          case '船舶调配':
            this._vehiclGetChildByPosition();
            break;
          case '转船':
            this._changeShipSelectCarByShipIdAndOut();
            break;

        }
      },
      determine() {
        this.$emit('tableId', this.selectTable);
      },
      close() {
        console.log(this.selectTable);
        this.selectTable.forEach(value => {
          this.$refs.carTableRef.toggleRowSelection(this.EntrustTable.find((item) => {
            return value.id === item.id;
          }), false);
        });
      },
      //取消事件  调用父组件关闭弹窗及清除勾选框
      close2() {
        this.CloseDialog();
      },
      // 父组件调用 用于回显
      async selectEcho() {
        //先清空选择
        this.tableLoad = false;
        console.log(this.selectTableId);
        let res = await changeShipSelectCarByShipIdAndOut({
          personnelId: this.positionData.shipId,
          ...this.EntrustForm,
          rows: 99999,
        });
        // this.$refs.carTableRef.clearSelection()
        this.$nextTick(() => {
          // 传入的id 集合
          if (this.selectTableId) {
            console.log(this.selectTableId);
            this.selectTableId.forEach(val => {
              // 只有使用表格原数据，才会生效   从表格原数据中赛选
              if (res.data.records && this.EntrustTable.length > 0) {
                res.data.records.forEach(item => {
                  if (val.id === item.id) {
                    console.log(val.id, item.id);
                    this.$refs.carTableRef.toggleRowSelection(item, true);
                  }
                });
              }
              // this.$refs.carTableRef.toggleRowSelection(this.EntrustTable.find((item) => { return val.id == item.id }));
            });
          }
        });
        this.EntrustTable = res.data.records.length > 10 ? res.data.records.splice(0, 10) : res.data.records;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .entrust {
    width: 100%;

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }

    ::v-deep.footer {
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      margin-top: 25px;

      .el-form-item {
        margin-bottom: 0;
      }
    }
  }

  ::v-deep {
    .el-table td, .el-table th {
      padding: 5px 0px !important;
    }
  }
</style>
